const model = process.env.NODE_ENV === 'development' || process.env.SNOOP_COOKIE_ENABLE_VALIDATION === 'true'
    ? require('./model.dev.js')
    : require('./model.prod.js')


export const { ArrayOf } = model
export const { OneOf } = model
export const { Optional } = model
export const { toObjectModel } = model
export const { formatErrors } = model
export const { validateIfIsModel } = model
export const { isModelNoLog } = model
export const { isModel } = model
export const { throwIfNotModel } = model
export const { rejectIfNotModel } = model
export const { isFontSize } = model
